/**
 * fancyboxGallery Component
 *
 * @file slider.js
 */

import $ from "jquery";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel, Scrollbar } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel, Scrollbar]);

import 'swiper/swiper-bundle.css';


const fancyboxGallery = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const defaultFancybox = () => {
    Fancybox.bind('[data-fancybox]', {
      // Custom options for all galleries
    }); 
    Fancybox.bind('[data-fancybox="home-video-gallery"]', {
      // Custom options for all galleries
      Thumbs:false
    }); 
    $('.cookie-accept').on('click', function(){
      Fancybox.close();
    });  
  };

  const balloonModal = () => {
    var e = document.getElementsByClassName("svg-map-hr")
      , t = document.querySelector(".map-balloon");
    for (let i = 0; i < e.length; i += 1) {
      e[i].addEventListener("mouseover", function(e) {
          if (e.target.getAttribute("data-value") === "1"){
            $(".svg-map-hr").addClass("hover");
            if (e.target.getAttribute("data-box2") !== null){
              t.innerHTML = ['<div class="map-box-item">', e.target.getAttribute("data-box") + e.target.getAttribute("data-box2"), "</div>"].join("");
            }  else{
              t.innerHTML = ['<div class="map-box-item">', e.target.getAttribute("data-box"), "</div>"].join("");
            }
          } else{
            t.innerHTML = ""
            $(".svg-map-hr").removeClass("hover");
          }
      });
      e[i].addEventListener("mousemove", function(e) {
          var t = $(this).parent().offset(),
          mouse_x = e.pageX - t.left + -170 + "px",
          mouse_y = e.pageY - t.top + -150 + "px",
          mouse_x = mouse_x,
          mouse_y = mouse_y;
          $(".map-balloon").css({
              left: mouse_x,
              top: mouse_y
          });
      }),
      e[i].addEventListener("mouseout", function(e) {
          t.innerHTML = "";
          $(".svg-map-hr").removeClass("hover");
      });
    }
  };

  const popupImgCarousel = () => {
    Fancybox.bind('[data-fancybox="popupGallery"]', {
      groupAttr: false,
      dragToClose:false,
      hash : false,
      on: {
        done: (fancybox, eventName) => {
          var popupTextCarousel = new Swiper('.text-'+eventName.contentEl.id+"-carousel", {
            slidesPerView: 1.5,
            spaceBetween: 30,
            watchSlidesProgress: true,
            direction:"vertical",
            observer:true,
            observeParents:true,
            mousewheel: {
            	releaseOnEdges: true,
            },
            touchReleaseOnEdges: true,
            scrollbar: {
              el: '.swiper-scrollbar',
              draggable: true,
            },
            breakpoints: {
              0: {
                direction:"horizontal",
                slidesPerView: 1.2,
                spaceBetween: 15,
                // centeredSlides: false,
              },
              768: {
                slidesPerView: 1.5,
                spaceBetween: 15,
                direction:"vertical",
                // centeredSlides: true,
              },
              992: {
                slidesPerView: 1.5,
                spaceBetween: 30,
              },
            }
          });
          var popupImgCarousel = new Swiper('.img-'+eventName.contentEl.id+"-carousel", {
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
          });
          popupTextCarousel.on('slideChange', function () {
            popupImgCarousel.slideTo(this.realIndex);	
          });
          popupTextCarousel.on('reachEnd', function () {
            $(".dty-popup-carousel-text .swiper-slide").addClass("last-ph");
          });
          popupTextCarousel.on('fromEdge', function(){
            $(".dty-popup-carousel-text .swiper-slide").removeClass("last-ph");
         });
        },
        close: (fancybox, eventName) => {
          var popupTextCarousel = new Swiper('.text-'+fancybox.userSlides[0].src.replace("#", "")+"-carousel", {
            slidesPerView: 1.5,
            spaceBetween: 30,
            watchSlidesProgress: true,
            direction:"vertical",
            observer:true,
            observeParents:true,
            mousewheel: {
            	releaseOnEdges: true,
            },
            touchReleaseOnEdges: true,
            scrollbar: {
              el: '.swiper-scrollbar',
              draggable: true,
            },
            breakpoints: {
              0: {
                direction:"horizontal",
                slidesPerView: 1.2,
                spaceBetween: 15,
                // centeredSlides: false,
              },
              768: {
                slidesPerView: 1.5,
                spaceBetween: 15,
                direction:"vertical",
                // centeredSlides: true,
              },
              992: {
                slidesPerView: 1.5,
                spaceBetween: 30,
              },
            }
          });
          var popupImgCarousel = new Swiper('.img-'+fancybox.userSlides[0].src.replace("#", "")+"-carousel", {
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
          });
          popupTextCarousel.update();
          popupImgCarousel.update();
        },
      },
    });
  };

  const customSelect = () => {
    var x, i, j, l, ll, selElmnt, a, b, c;
    /*look for any elements with the class "custom-select":*/
    x = document.getElementsByClassName("custom-select");
    l = x.length;
    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      ll = selElmnt.length;
      /*for each element, create a new DIV that will act as the selected item:*/
      a = document.createElement("DIV");
      a.setAttribute("class", "select-selected");
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      x[i].appendChild(a);
      /*for each element, create a new DIV that will contain the option list:*/
      b = document.createElement("DIV");
      b.setAttribute("class", "select-items select-hide");
      for (j = 1; j < ll; j++) {
        /*for each option in the original select element,
        create a new DIV that will act as an option item:*/
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.addEventListener("click", function(e) {
            /*when an item is clicked, update the original select box,
            and the selected item:*/
            var y, i, k, s, h, sl, yl;
            s = this.parentNode.parentNode.getElementsByTagName("select")[0];
            sl = s.length;
            h = this.parentNode.previousSibling;
            for (i = 0; i < sl; i++) {
              if (s.options[i].innerHTML == this.innerHTML) {
                s.selectedIndex = i;
                h.innerHTML = this.innerHTML;
                y = this.parentNode.getElementsByClassName("same-as-selected");
                yl = y.length;
                for (k = 0; k < yl; k++) {
                  y[k].removeAttribute("class");
                }
                this.setAttribute("class", "same-as-selected");
                break;
              }
            }
            h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener("click", function(e) {
          /*when the select box is clicked, close any other select boxes,
          and open/close the current select box:*/
          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
        });
    }
    function closeAllSelect(elmnt) {
      /*a function that will close all select boxes in the document,
      except the current select box:*/
      var x, y, i, xl, yl, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i)
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }
    /*if the user clicks anywhere outside the select box,
    then close all select boxes:*/
    document.addEventListener("click", closeAllSelect);
  };

  // const orientationModal = () => {
  //   const modal = document.querySelector('.user-orientation-modal');
  //   const modalBackdrop = modal.querySelector('.backdrop');
  //   modalBackdrop.addEventListener('click', function(e){
  //     console.log(e.target);
  //     if(e.target.classList.contains('backdrop')){
  //       modal.classList.remove('show-user-orientation-modal');
  //     }
  //   });
  // };

  const init = () => {
    defaultFancybox();
    balloonModal();
    customSelect();
    popupImgCarousel();
    // orientationModal();
  };

  return {
    init,
  };
})();

export default fancyboxGallery;